import PermissionsGuard, { Permissions } from '@components/PermissionsGuard/PermissionsGuard'
import { Button, Typography } from '@mui/material'
import { buildEnv } from '@utils/EnvironmentHelper'
import { Link } from 'react-router-dom'

type Props = {
	onClose: () => void
}

export default function Version({ onClose }: Props) {
	let fullVersion = import.meta.env.VITE_APP_VERSION
	let condensedVersion = fullVersion ? fullVersion.split('-')[0] : null
	const gitHash = import.meta.env.VITE_GIT_HASH

	if (buildEnv !== 'production') {
		condensedVersion = gitHash
		fullVersion = null
	}

	return (
		<>
			<PermissionsGuard showWhenHasPermission={[Permissions.WonderlandView]} disableNotAuthorized>
				<Link to="/app/settings">
					<Button variant="contained" onClick={onClose} data-testid="version-button">
						Version: {condensedVersion}
					</Button>
				</Link>
			</PermissionsGuard>

			<PermissionsGuard showWhenMissingPermission={[Permissions.WonderlandView]}>
				<Typography>Version: {condensedVersion}</Typography>
			</PermissionsGuard>
		</>
	)
}
